import { connect } from "react-redux";
import AccountSubbar from "./AccountSubbar";
import { setAccountTab } from "./actions/route";

const mapStateToProps = (state, ownProps) => {
  return {
    tabIndex: state.route.accountTabIndex,
    labels: state.route.accountTabLabels,
    loading: state.ui.loadingAccounts
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    persistTab: index => {
      dispatch(setAccountTab(index));
    }
  };
};

const AccountSubbarContainer = connect(mapStateToProps, mapDispatchToProps)(
  AccountSubbar
);

export default AccountSubbarContainer;



// WEBPACK FOOTER //
// ./src/AccountSubbarContainer.js